import { defineMessages } from 'react-intl';

export const mcpLegalDisclaimerMessages = defineMessages({
  agreementHeader: {
    id: 'oauth.mcp.bestPracticesHeader',
    defaultMessage: "By accepting, you agree to {product}'s ",
    description:
      'Header for the legal disclaimer agreement list; {product} is dynamic based on what is passed in',
  },
  agreementBulletTwo: {
    id: 'oauth.mcp.bestPracticesBulletTwo',
    defaultMessage: '{privacyPolicyLink} and {termsOfUseLink}.',
    description:
      'Legal disclaimer bullet about privacy policy and terms of use',
  },
  privacyPolicy: {
    id: 'oauth.mcp.privacyPolicy',
    defaultMessage: 'privacy policy',
    description: 'Link text for the privacy policy',
  },
  termsOfUse: {
    id: 'oauth.mcp.termsOfUse',
    defaultMessage: 'terms of use',
    description: 'Link text for the terms of use',
  },
});
